import { IFetchedAIRecommendation } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

// 이미지를 이용하여 AI 추천 필터 및 태그 불러오기
async function getImageAIRecommendation(variables: {
  s3Path: string;
  key: string;
  parentOptionId: number;
}): Promise<AxiosResponse<FetchResult<IFetchedAIRecommendation>>> {
  const response = await instance.get(
    `/ai/image-tag-suggestions?s3Path=${variables.s3Path}&key=${variables.key}&parentOptions=${variables.parentOptionId}`
  );
  return response;
}

// 사용자 액션에 따라 데이터를 조회해야 하므로 useMutation 이용
const useFetchImageAIRecommendation = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['get', `/ai/image-tag-suggestions`],
    mutationFn: (variables: { s3Path: string; key: string; parentOptionId: number }) =>
      getImageAIRecommendation(variables),
    retry: false
  });

  return { mutateAsync, isPending };
};

export default useFetchImageAIRecommendation;
